import { Link } from "react-router-dom";
import * as icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, PageHero } from "../components/Reveal";
import { INDUSTRIES } from "../data/site";
import useSeo from "../components/Seo";

export default function Industries() {
  useSeo("Industries We Serve", "Transportation solutions for manufacturing, construction, infrastructure, engineering, automotive, retail and distribution, industrial projects and corporate clients.");
  return (
    <>
      <PageHero
        overline="Industries"
        lines={[<>Serving the sectors that</>, <>keep India <em className="italic text-gold-light">moving</em></>]}
        desc="We structure transportation around the realities of each industry — its schedules, its sites and its standards."
      />

      <section className="py-24 sm:py-32" data-testid="industries-grid-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid gap-px border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-4">
            {INDUSTRIES.map((ind, i) => {
              const Icon = icons[ind.icon] || icons.Factory;
              return (
                <Reveal key={ind.title} delay={0.05 * (i % 4)} className="h-full">
                  <article
                    className="group flex h-full flex-col bg-ink p-9 transition-colors duration-500 hover:bg-smoke"
                    data-testid={`industry-card-${i}`}
                  >
                    <div className="flex items-start justify-between">
                      <Icon className="h-6 w-6 text-gold transition-colors duration-300 group-hover:text-gold-light" strokeWidth={1.5} />
                      <span className="font-heading text-sm text-gold/70">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <h2 className="mt-10 font-heading text-lg leading-snug text-foreground transition-colors duration-300 group-hover:text-gold-light">{ind.title}</h2>
                    <p className="mt-3 flex-1 text-sm leading-[1.8] text-muted-foreground">{ind.desc}</p>
                    <div className="mt-8 h-px w-10 bg-gold/25 transition-all duration-500 group-hover:w-full group-hover:bg-gold/50" />
                  </article>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-24 flex flex-col items-start justify-between gap-10 border border-gold/20 bg-surface p-10 sm:flex-row sm:items-center sm:p-14" data-testid="industries-closing-panel">
              <div>
                <p className="overline-gold">Beyond the List</p>
                <h2 className="mt-4 font-heading text-2xl text-foreground sm:text-3xl">Your industry, our responsibility</h2>
                <p className="mt-4 max-w-xl text-sm leading-[1.85] text-muted-foreground">
                  If your sector depends on reliable road movement, we would like to understand your requirement.
                </p>
              </div>
              <Link to="/quote" className="btn-solid group shrink-0" data-testid="industries-quote-cta">
                Request a Quote
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
